/**
 * Custom Header - Navigation & Mobile Menu
 */

(function() {
  'use strict';

  const header = document.querySelector('[data-scroll-header]');
  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const cartCount = document.getElementById('custom-cart-count');

  if (!header) return;

  // Scroll behavior
  let lastScroll = 0;

  window.addEventListener('scroll', function() {
    const currentScroll = window.scrollY;

    if (currentScroll > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }

    lastScroll = currentScroll;
  });

  // Mobile menu toggle
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function() {
      const isActive = mobileMenu.classList.contains('active');

      if (isActive) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });

    // Close mobile menu when clicking outside
    mobileMenu.addEventListener('click', function(e) {
      if (e.target === mobileMenu) {
        closeMobileMenu();
      }
    });

    // Close on link click
    const mobileLinks = mobileMenu.querySelectorAll('.custom-mobile-link');
    mobileLinks.forEach(link => {
      link.addEventListener('click', closeMobileMenu);
    });
  }

  function openMobileMenu() {
    mobileMenu.classList.add('active');
    mobileToggle.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    mobileMenu.classList.remove('active');
    mobileToggle.classList.remove('active');
    document.body.style.overflow = '';
  }

  // Update cart count
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cartCount) {
          cartCount.textContent = cart.item_count;
          if (cart.item_count === 0) {
            cartCount.style.display = 'none';
          } else {
            cartCount.style.display = 'block';
          }
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  // Listen for cart updates
  document.addEventListener('cart:updated', updateCartCount);

  // Initial cart count update
  updateCartCount();

  // Listen for Shopify cart changes
  if (window.Shopify && window.Shopify.onCartUpdate) {
    const originalOnCartUpdate = window.Shopify.onCartUpdate;
    window.Shopify.onCartUpdate = function(cart) {
      if (originalOnCartUpdate) {
        originalOnCartUpdate(cart);
      }
      updateCartCount();
    };
  }

})();
